<template>
  <div class="flex flex-1 flex-col">
    <FlotoPageHeader class="px-4">
      <template v-slot:title class="mx-2 ml-2">
        {{ $tc('my_ci') }}
      </template>
      <template v-slot:after-title>
        <MTooltip>
          <template v-slot:trigger>
            <MButton
              class="mx-1"
              variant="neutral-lighter"
              shape="circle"
              :shadow="false"
              @click="refreshList"
            >
              <MIcon name="sync" />
            </MButton>
          </template>
          {{ $t('refresh') }}
        </MTooltip>
      </template>
    </FlotoPageHeader>
    <FlotoLoadError v-if="error" :authorization-error="error">
      <MButton @click="reset">
        {{ $t('reload') }}
      </MButton>
    </FlotoLoadError>
    <AssetSelectionList
      v-else
      ref="list"
      client-side-pagination
      :module-name="$constants.CMDB"
      :fetch-fn="fetchAssetFn"
      :searchable="false"
      show-no-data
      show-barcode-and-qrcode
      scrollable
      :hidden-columns="['assignedUserIds']"
      :has-actions="false"
      :linkable="false"
    />
  </div>
</template>

<script>
import AssetSelectionList from '@components/item-selection-list/asset-list'
import { getMyAssetApi } from '@modules/asset/asset-api'
import { transformAssetForList } from '@data/asset'
import { SupportPortalConfigComputed } from '@state/modules/support-portal-config/helpers'

export default {
  name: 'UserAssets',
  components: { AssetSelectionList },
  props: {
    moduleName: {
      type: String,
      default() {
        return this.$constants.CMDB
      },
    },
  },
  data() {
    return {
      error: undefined,
    }
  },
  computed: {
    ...SupportPortalConfigComputed,
  },
  created() {
    if (!this.allowReqToAccessMyCi) {
      this.$router.replace({ name: '404' })
    }
  },
  methods: {
    fetchAssetFn(pageSize, offset) {
      return getMyAssetApi(this.moduleName)
        .then((data) => {
          return (data.objectList || []).map(
            (i) => transformAssetForList({ ...i, relationId: 'fake_id' }) // add fake relation id for combined ids
          )
          // return {
          //   items: (data.objectList || []).map(
          //     (i) => transformAssetForList({ ...i, relationId: 'fake_id' }) // add fake relation id for combined ids
          //   ),
          //   total: data.totalCount,
          // }
        })
        .catch((e) => {
          this.error = e.response
        })
    },
    refreshList() {
      this.$refs.list.refresh()
    },
  },
}
</script>
